import React, { useMemo, useEffect, useRef, useState } from "react";

import Programmes from "./home-components/Programmes";
import Alumni from "./home-components/Alumni";
import Recruiters from "./home-components/Recruiters";
import Awards from "./home-components/Awards";
import Campuses from "./home-components/Campuses";
import Facilities from "./home-components/Facilities";
import Blogs from "./home-components/Blogs";
import FAQ from "./home-components/FAQ";
import Footer from "./components/Footer";
import Header from "./components/Header";
import MetaInfo from "./components/MetaInfo";

import banner1 from "./assets/img/banner-1.png";
import banner2 from "./assets/img/banner-2.png";
import banner3 from "./assets/img/banner-3.png";
import banner4 from "./assets/img/banner-4.png";
import banner5 from "./assets/img/banner-5.png";

import about1 from "./assets/img/about-1.webp";
import about2 from "./assets/img/about-2.webp";

import p1 from "./assets/img/programs/Research-and-Development.jpg";
import p2 from "./assets/img/programs/Post-Graduation.jpg";
import p3 from "./assets/img/programs/Graduation.jpg";
import p4 from "./assets/img/programs/diploma.jpg";
import p5 from "./assets/img/programs/Certificate.jpg";

import arrow from "./assets/img/programs/arrow.webp";

import abertayLogo from "./assets/img/partnership/abertay.png";
import diuLogo from "./assets/img/partnership/diu.webp";
import henryLogo from "./assets/img/partnership/henry.webp";
import indianaLogo from "./assets/img/partnership/indiana.webp";
import rushfordLogo from "./assets/img/partnership/rushford.webp";
import placement1 from "./assets/img/placement/placement1.jpeg";
import placement2 from "./assets/img/placement/placement2.jpg";
import placement3 from "./assets/img/placement/placement3.jpg";
import placement4 from "./assets/img/placement/placement4.jpg";

import { Eyebrow, Title } from "./components/CommonComponents";
import Accreditations from "./home-components/Accreditations";

const placementGallery = [placement1, placement2, placement3, placement4];

const placementStats = [
  {
    value: 6500,
    suffix: "+",
    label: "Placements",
  },
  {
    value: 45,
    suffix: " LPA",
    label: "Highest Offer",
  },
  {
    value: 25,
    suffix: " LPA",
    label: "Average Offer",
  },
  {
    value: 250,
    suffix: "+",
    label: "Companies Hired",
  },
  {
    value: 150,
    suffix: "+",
    label: "Companies Visited",
  },
  {
    value: 95,
    suffix: "%",
    label: "Students Placed",
  },
];

function AnimatedStat({ value, suffix = "", duration = 1800, label, index }) {
  const counterRef = useRef(null);
  const [displayValue, setDisplayValue] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    const element = counterRef.current;

    if (!element) return undefined;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (prefersReducedMotion) {
      setDisplayValue(value);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted) {
          setHasStarted(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.35,
      },
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [hasStarted, value]);

  useEffect(() => {
    if (!hasStarted) return undefined;

    let animationFrame;
    let startTime;

    const animateCounter = (timestamp) => {
      if (!startTime) startTime = timestamp;

      const elapsedTime = timestamp - startTime;
      const progress = Math.min(elapsedTime / duration, 1);

      // Smooth ease-out animation
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const currentValue = Math.floor(easedProgress * value);

      setDisplayValue(currentValue);

      if (progress < 1) {
        animationFrame = window.requestAnimationFrame(animateCounter);
      } else {
        setDisplayValue(value);
      }
    };

    animationFrame = window.requestAnimationFrame(animateCounter);

    return () => window.cancelAnimationFrame(animationFrame);
  }, [hasStarted, value, duration]);

  return (
    <article
      className="placement-stat"
      ref={counterRef}
      style={{ "--stat-delay": `${index * 70}ms` }}
    >
      <span className="placement-stat__number" aria-hidden="true">
        {String(index + 1).padStart(2, "0")}
      </span>

      <h3>
        {displayValue.toLocaleString("en-IN")}
        <small>{suffix}</small>
      </h3>

      <span className="placement-stat__label">{label}</span>
    </article>
  );
}

const slides = [
  {
    kicker: "A TOP PRIVATE UNIVERSITY",
    title: (
      <>
        Rooted in Excellence
        <br />
        <em>A Launchpad for Ambitions.</em>
      </>
    ),
    text: "Recognised as the best university in Chhattisgarh ISBM University is a NAAC-accredited and UGC-approved institution shaping careers through industry oriented learning.",
    primary: "About Us",
    secondary: "Explore Programmes",
    primaryhref: "/about-us",
    secondaryhref: "/programmes",
    image: banner1,
    alt: "A TOP PRIVATE UNIVERSITY",
  },
  {
    kicker: "Global Recognition",
    title: (
      <>
        Built on Quality.
        <br />
        <em>Connected to the World.</em>
      </>
    ),
    text: "ISBM University is NAAC-accredited and backed by International Association of Universities(IAU), and Association to Advance Collegiate Schools of Business (AACSB)  to strengthen learning through quality standards, collaboration, and global perspectives.",
    primary: "Visit Our Accreditations",
    secondary: "Our Global Partners",
    primaryhref: "/accreditation-and-recognitions",
    secondaryhref: "/international-partnerships",
    image: banner2,
    alt: "Global Recognition",
  },
  {
    kicker: "UGC Approved University",
    title: (
      <>
        Accredited By the Best.
        <br />
        <em>Approved By the Strongest.</em>
      </>
    ),
    text: "Your education is not only accredited by UGC and AICTE, but also authorized by highly-reputable summits such as the Bar Council and Pharmacy Council.",
    primary: "Our Quality Standard",
    secondary: "Apply Now",
    primaryhref: "/accreditation-and-recognitions",
    secondaryhref: "/about-us",
    image: banner3,
    alt: "Assured For Future Success",
  },
  {
    kicker: "Dual-Campus Ecosystem",
    title: (
      <>
        A Ground To Grow,
        <br />
        <em>Thrive and Shine</em>
      </>
    ),
    text: "With our dual-campus system set amidst the prime locations of Chhattisgarh, your academic life will have more space for growth.",
    primary: "Check Out - Gariyaband Campus",
    secondary: "Check Out - Raipur Campus",
    primaryhref: "/gariyaband-campus",
    secondaryhref: "/raipur-campus",
    image: banner4,
    alt: "Dual-Campus Ecosystem",
  },
  {
    kicker: "Dedicated Placement Assistance",
    title: (
      <>
        From Learning.
        <br />
        <em>To Opportunities.</em>
      </>
    ),
    text: "We help students develop skills, build confidence, explore global opportunities, and prepare for meaningful careers.",
    primary: "Placement Cell",
    secondary: "Our Top Recruiters",
    primaryhref: "/about-placements",
    secondaryhref: "/recruiters",
    image: banner5,
    alt: "Dedicated Placement Assistance",
  },
];

const recognitions = [
  {
    mark: "NAAC",
    title: "NAAC Accredited University",
    description:
      "Recognized for academic excellence and quality education in India.",
  },
  {
    mark: "AACSB",
    title: "AACSB Business Education Alliance",
    description: "Globally aligned with leading business education standards.",
  },
  {
    mark: "IAU",
    title: "International Association of Universities",
    description: "Connected to a worldwide higher-education community.",
  },
];

const differentiators = [
  {
    icon: "briefcase",
    title: "Startup Incubation and Placements",
    description:
      "Ideas, mentoring and industry pathways that turn ambition into opportunity.",
  },
  {
    icon: "globe",
    title: "International Academic Programmes",
    description:
      "Globally relevant learning experiences and academic collaborations.",
  },
  {
    icon: "shield",
    title: "Skill Development",
    description:
      "Practical capabilities shaped through projects, workshops and mentoring.",
  },
  {
    icon: "graduation",
    title: "Career Readiness & Soft Skills",
    description:
      "Professional confidence, communication and workplace preparation.",
  },
];

const universityStats = [
  {
    value: "18+",
    label: "Specialized schools offering future-focused programmes",
  },
  {
    value: "200+",
    label: "Professionals dedicated to academic and career success",
  },
  { value: "5000+", label: "Applicants trust ISBM University every year" },
  {
    value: "100+",
    label: "Leading companies actively recruiting our graduates",
  },
];

const newsletters = [
  {
    issue: "Issue 08",
    season: "July 2026",
    title: "Campus Chronicle",
    description:
      "A monthly collection of academic achievements, student activities, research updates and stories from across the University.",
    image:
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=1200&q=88",
    link: "/newsletters/campus-chronicle-july-2026",
    featured: true,
  },
  {
    issue: "Issue 07",
    season: "June 2026",
    title: "Research & Innovation Digest",
    description:
      "Highlights from research, faculty contributions and innovation-led learning.",
    image:
      "https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=900&q=85",
    link: "/newsletters/research-digest-june-2026",
  },
  {
    issue: "Issue 06",
    season: "May 2026",
    title: "Student Success Bulletin",
    description:
      "Celebrating student projects, competitions, placements and campus milestones.",
    image:
      "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=900&q=85",
    link: "/newsletters/student-success-may-2026",
  },
  {
    issue: "Issue 05",
    season: "April 2026",
    title: "Industry Connect",
    description:
      "Workshops, expert sessions, academic collaborations and career-focused initiatives.",
    image:
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=900&q=85",
    link: "/newsletters/industry-connect-april-2026",
  },
];

const events = [
  {
    day: "12",
    month: "AUG",
    year: "2026",
    category: "Orientation",
    title: "New Student Orientation Programme 2026",
    location: "University Auditorium",
    time: "10:00 AM onwards",
    description:
      "A welcoming introduction to academics, campus services, student life and the University community.",
    image:
      "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1000&q=85",
    link: "/events/student-orientation-2026",
  },
  {
    day: "24",
    month: "AUG",
    year: "2026",
    category: "Academic",
    title: "Future Skills and Emerging Careers Conclave",
    location: "Seminar Hall",
    time: "11:00 AM",
    description:
      "Industry professionals and academicians discuss evolving skills, technology and new career pathways.",
    image:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1000&q=85",
    link: "/events/future-skills-conclave",
  },
  {
    day: "05",
    month: "SEP",
    year: "2026",
    category: "Student Life",
    title: "University Cultural and Literary Fest",
    location: "Main Campus",
    time: "09:30 AM onwards",
    description:
      "A celebration of creativity, expression and student talent through cultural and literary activities.",
    image:
      "https://images.unsplash.com/photo-1505236858219-8359eb29e329?auto=format&fit=crop&w=1000&q=85",
    link: "/events/university-cultural-fest",
  },
  {
    day: "18",
    month: "SEP",
    year: "2026",
    category: "Careers",
    title: "Career Readiness and Placement Workshop",
    location: "Training & Placement Cell",
    time: "02:00 PM",
    description:
      "Practical sessions on professional communication, aptitude, interviews and career preparation.",
    image:
      "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1000&q=85",
    link: "/events/career-readiness-workshop",
  },
];

const circulars = [
  {
    date: "22 Jul 2026",
    type: "Academic",
    title: "Academic Calendar and Semester Activity Schedule",
    ref: "ISBMU/ACAD/2026/042",
    format: "PDF",
    link: "/circulars/academic-calendar-2026",
  },
  {
    date: "18 Jul 2026",
    type: "Examination",
    title: "Guidelines for Internal Assessment and Project Submission",
    ref: "ISBMU/EXAM/2026/039",
    format: "PDF",
    link: "/circulars/internal-assessment-guidelines",
  },
  {
    date: "10 Jul 2026",
    type: "Student Services",
    title: "Student Identity Card and Campus Access Instructions",
    ref: "ISBMU/ADMIN/2026/035",
    format: "PDF",
    link: "/circulars/campus-access-instructions",
  },
  {
    date: "02 Jul 2026",
    type: "Library",
    title: "Library Membership and Digital Resource Access",
    ref: "ISBMU/LIB/2026/031",
    format: "PDF",
    link: "/circulars/library-resource-access",
  },
];

const notices = [
  {
    date: "25",
    month: "JUL",
    tag: "New",
    title: "Registration Open for Student Clubs and Committees",
    description:
      "Students may submit their preferences through the student services desk.",
    link: "/notices/student-club-registration",
  },
  {
    date: "21",
    month: "JUL",
    tag: "Important",
    title: "Document Verification Schedule for Newly Admitted Students",
    description:
      "Students should report with original documents and the admission acknowledgement.",
    link: "/notices/document-verification-schedule",
  },
  {
    date: "16",
    month: "JUL",
    tag: "Campus",
    title: "Hostel Reporting and Accommodation Guidelines",
    description:
      "Residential students are requested to review reporting dates and hostel instructions.",
    link: "/notices/hostel-reporting-guidelines",
  },
  {
    date: "08",
    month: "JUL",
    tag: "Careers",
    title: "Applications Invited for Career Development Workshops",
    description:
      "Limited seats are available for programme-specific career preparation sessions.",
    link: "/notices/career-development-workshops",
  },
];

function SectionHeading({ eyebrow, title, accent, description, link, dark }) {
  return (
    <header className={`info-heading ${dark ? "info-heading--dark" : ""}`}>
      <div>
        <span className="info-eyebrow">
          <i />
          {eyebrow}
        </span>
        <h2>
          {title}
          <em>{accent}</em>
        </h2>
      </div>
      <div className="info-heading__aside">
        <p>{description}</p>
        <a href={link}>
          View all <span>↗</span>
        </a>
      </div>
    </header>
  );
}

export function NewslettersSection() {
  const featured = newsletters.find((item) => item.featured);
  const archive = newsletters.filter((item) => !item.featured);

  return (
    <section
      className="newsletter-section newsletter-section--no-images"
      aria-labelledby="newsletter-heading"
    >
      <div className="info-container">
        <SectionHeading
          eyebrow="University publications"
          title="Stories from across"
          accent=" our community."
          description="Explore academic developments, student achievements, research highlights and important moments from university life."
          link="/newsletters"
        />

        <div className="newsletter-layout">
          {/* Latest newsletter */}
          <article className="newsletter-featured">
            <div className="newsletter-document-cover">
              <div className="newsletter-document-cover__top">
                <span>ISBM</span>
                <strong>UNIVERSITY</strong>
              </div>

              <div className="newsletter-document-cover__edition">
                <small>{featured.issue}</small>
                <span>{featured.season}</span>
              </div>

              <div className="newsletter-document-cover__title">
                <small>Official University Newsletter</small>
                <h3>{featured.title}</h3>
                <p>Knowledge · Wisdom · Humanity</p>
              </div>

              <span
                className="newsletter-document-cover__mark"
                aria-hidden="true"
              >
                N
              </span>
            </div>

            <div className="newsletter-featured__copy">
              <span>{featured.season} · Latest edition</span>

              <h3>{featured.title}</h3>

              <p>{featured.description}</p>

              <div className="newsletter-featured__meta">
                <div>
                  <small>Publication</small>
                  <strong>{featured.issue}</strong>
                </div>

                <div>
                  <small>Published</small>
                  <strong>{featured.season}</strong>
                </div>
              </div>

              <a href={featured.link}>
                Read latest edition <i>↗</i>
              </a>
            </div>
          </article>

          {/* Previous newsletters */}
          <div className="newsletter-archive">
            <div className="newsletter-archive__label">
              <div>
                <span>Previous editions</span>
                <small>Browse the University newsletter archive</small>
              </div>

              <strong>{String(archive.length).padStart(2, "0")}</strong>
            </div>

            {archive.map((item, index) => (
              <a
                href={item.link}
                className="newsletter-archive__item"
                key={item.title}
              >
                <span className="newsletter-archive__number">
                  {String(index + 2).padStart(2, "0")}
                </span>

                <span
                  className={`newsletter-mini-cover newsletter-mini-cover--${(index % 3) + 1
                    }`}
                  aria-hidden="true"
                >
                  <small>ISBMU</small>
                  <strong>{item.season}</strong>
                  <i>N</i>
                </span>

                <span className="newsletter-archive__copy">
                  <small>
                    {item.issue} · {item.season}
                  </small>

                  <strong>{item.title}</strong>

                  <p>{item.description}</p>
                </span>

                <span className="newsletter-archive__action">
                  View <i>↗</i>
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function EventsSection() {
  return (
    <section className="events-section" aria-labelledby="events-heading">
      <div className="events-section__pattern" aria-hidden="true">
        EVENTS
      </div>
      <div className="info-container">
        <SectionHeading
          eyebrow="What’s happening"
          title="Meet, participate"
          accent=" and experience."
          description="Discover upcoming academic, cultural and career-focused experiences bringing the university community together."
          link="/events"
          dark
        />

        <div className="events-list">
          {events.map((event, index) => (
            <article className="event-row" key={event.title}>
              <div className="event-row__date">
                <strong>{event.day}</strong>
                <span>{event.month}</span>
                <small>{event.year}</small>
              </div>
              <div className="event-row__image">
                <img src={event.image} alt="" loading="lazy" />
                <span>0{index + 1}</span>
              </div>
              <div className="event-row__content">
                <span>{event.category}</span>
                <h3>{event.title}</h3>
                <p>{event.description}</p>
                <div>
                  <small>⌖ {event.location}</small>
                  <small>◷ {event.time}</small>
                </div>
              </div>
              <a href={event.link} aria-label={`View ${event.title}`}>
                ↗
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CircularsNoticesSection() {
  const [activeType, setActiveType] = useState("All");
  const types = ["All", ...new Set(circulars.map((item) => item.type))];
  const visibleCirculars = useMemo(
    () =>
      activeType === "All"
        ? circulars
        : circulars.filter((item) => item.type === activeType),
    [activeType],
  );

  return (
    <section className="updates-section" aria-labelledby="updates-heading">
      <div className="info-container">
        <SectionHeading
          eyebrow="Official updates"
          title="Stay informed."
          accent=" Stay connected."
          description="Access official university circulars, academic instructions, administrative updates and current notices."
          link="/notices"
        />

        <div className="updates-grid">
          <div className="circular-panel">
            <div className="updates-panel__heading">
              <div>
                <span>Official documents</span>
                <h3>Circulars</h3>
              </div>
              <a href="/circulars">View archive ↗</a>
            </div>
            <div
              className="circular-filters"
              role="tablist"
              aria-label="Filter circulars"
            >
              {types.map((type) => (
                <button
                  key={type}
                  type="button"
                  className={activeType === type ? "active" : ""}
                  aria-selected={activeType === type}
                  onClick={() => setActiveType(type)}
                >
                  {type}
                </button>
              ))}
            </div>
            <div className="circular-list">
              {visibleCirculars.map((item) => (
                <a href={item.link} className="circular-item" key={item.ref}>
                  <span className="circular-item__format">{item.format}</span>
                  <span className="circular-item__copy">
                    <small>
                      {item.date} · {item.type}
                    </small>
                    <strong>{item.title}</strong>
                    <em>{item.ref}</em>
                  </span>
                  <i>↓</i>
                </a>
              ))}
            </div>
          </div>

          <div className="notice-panel">
            <div className="updates-panel__heading">
              <div>
                <span>Student information</span>
                <h3>Notices</h3>
              </div>
              <a href="/notices">View all ↗</a>
            </div>
            <div className="notice-list">
              {notices.map((item) => (
                <a href={item.link} className="notice-item" key={item.title}>
                  <span className="notice-item__date">
                    <strong>{item.date}</strong>
                    <small>{item.month}</small>
                  </span>
                  <span className="notice-item__copy">
                    <small>{item.tag}</small>
                    <strong>{item.title}</strong>
                    <p>{item.description}</p>
                  </span>
                  <i>↗</i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FeatureIcon({ type }) {
  if (type === "briefcase") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M8 7V5.7A1.7 1.7 0 0 1 9.7 4h4.6A1.7 1.7 0 0 1 16 5.7V7M4.5 8h15A1.5 1.5 0 0 1 21 9.5v8A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5v-8A1.5 1.5 0 0 1 4.5 8Z" />
        <path d="M3 12.2c5.7 2.2 12.3 2.2 18 0M10 13h4" />
      </svg>
    );
  }
  if (type === "globe") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="10" r="6" />
        <path d="M12 4c2.1 2.2 2.1 9.8 0 12M12 4c-2.1 2.2-2.1 9.8 0 12M6.4 8h11.2M6.4 12h11.2M12 16v4M9 20h6" />
      </svg>
    );
  }
  if (type === "shield") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 3.5c2.2 2 4.8 3.1 7.5 3.3v4.5c0 4.8-3 8.2-7.5 9.7-4.5-1.5-7.5-4.9-7.5-9.7V6.8C7.2 6.6 9.8 5.5 12 3.5Z" />
        <path d="m9 12 2 2 4-4" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m3 9 9-4 9 4-9 4-9-4Z" />
      <path d="M6.5 11.2v5.2c3.3 2 7.7 2 11 0v-5.2M21 9v6" />
    </svg>
  );
}

function Home() {
  const [slide, setSlide] = useState(0);
  const touchStart = useRef(0);

  useEffect(() => {
    const timer = window.setInterval(
      () => setSlide((s) => (s + 1) % slides.length),
      9500,
    );
    return () => window.clearInterval(timer);
  }, []);

  const go = (n) => setSlide((n + slides.length) % slides.length);
  return (
    <main>
      <MetaInfo param="" id="home" />

      <Header school="common" />

      <section
        id="main-content"
        className="relative h-full min-h-[85svh] overflow-hidden bg-[#071A2F] text-white"
        aria-label="University highlights"
        onTouchStart={(e) => (touchStart.current = e.touches[0].clientX)}
        onTouchEnd={(e) => {
          const d = e.changedTouches[0].clientX - touchStart.current;
          if (Math.abs(d) > 45) go(slide + (d < 0 ? 1 : -1));
        }}
      >
        {slides.map((s, i) => {
          const isActive = i === slide;

          return (
            <article
              className={`absolute inset-0 transition-[opacity,visibility] duration-[1100ms] ease-in-out ${isActive
                ? "visible opacity-100"
                : "invisible opacity-0"
                }`}
              key={i}
              aria-hidden={!isActive}
            >
              <img className={`absolute h-full w-full object-cover transition-transform duration-[8000ms] ease-in-out ${isActive ? "scale-100" : "scale-[1.06]"}`} src={s.image} alt={s.alt} />

              <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(3,17,32,0.95)_0%,rgba(4,23,42,0.7)_42%,rgba(4,20,36,0.18)_70%),linear-gradient(0deg,rgba(5,22,38,0.6),transparent_45%)]" />

              <div className="absolute left-[max(7vw,70px)] top-[35%] z-[2] max-w-[700px] -translate-y-[39%] max-[900px]:left-6 max-[900px]:right-6 max-[900px]:top-[48%] max-[900px]:-translate-y-[42%]" >
                <div className="mb-[22px] h-px w-11 bg-[#D5AD57]" />

                <p className="mb-[22px] mt-0 text-[11px] font-semibold uppercase tracking-[0.24em] text-[#F1D18A]">
                  {s.kicker}
                </p>

                {i === 0 ? (
                  <h1 className="m-0 font-['Libre_Caslon_Display'] text-[clamp(56px,6vw,94px)] font-normal leading-[0.98] tracking-[-0.035em] [&_em]:font-normal [&_em]:text-[#EFD28D] max-[900px]:text-[clamp(49px,14vw,70px)">
                    {s.title}
                  </h1>
                ) : (
                  <h2 className="m-0 font-['Libre_Caslon_Display'] text-[clamp(56px,6vw,94px)] font-normal leading-[0.98] tracking-[-0.035em] [&_em]:font-normal [&_em]:text-[#EFD28D]">
                    {s.title}
                  </h2>
                )}

                <p className="mb-8 mt-[25px] max-w-[570px] text-base leading-[1.7] text-white/75 max-[900px]:text-sm">
                  {s.text}
                </p>

                <div className="flex gap-3">
                  <a href={s.primaryhref}
                    className="flex h-[54px] items-center gap-[34px] bg-[#D5AD57] px-[25px] text-[10px] font-bold uppercase tracking-[0.1em] text-[#071A2F] transition duration-200 hover:-translate-y-0.5 hover:bg-[#E2BF70] hover:text-[#071A2F]">
                    {s.primary}
                    <span>→</span>
                  </a>

                  <a href={s.secondaryhref} className="flex h-[54px] items-center gap-[34px] border border-white/45 px-[25px] text-[10px] font-bold uppercase tracking-[0.1em] text-white transition duration-200 hover:bg-white hover:text-[#071A2F]">
                    {s.secondary}
                    <span>↗</span>
                  </a>
                </div>
              </div>
            </article>
          );
        })}

        {/* Slider controls */}
        <div className="absolute bottom-[42px] left-[max(7vw,70px)] z-[5] flex items-center max-[900px]:bottom-7 max-[900px]:left-6">
          <button
            type="button"
            onClick={() => go(slide - 1)}
            aria-label="Previous slide"
            className="h-[42px] w-[42px] cursor-pointer border border-white/35 bg-black/10 text-white transition duration-200 hover:bg-white hover:text-[#071A2F]">
            ←
          </button>

          <div className="mx-[15px] flex">
            {slides.map((_, i) => (
              <button
                type="button"
                key={i}
                onClick={() => go(i)}
                aria-label={`Go to slide ${i + 1}`}
                className="h-7 w-[38px] cursor-pointer border-0 bg-transparent px-1"
              >
                <span className={`relative block h-px bg-white/40 ${i === slide ? "after:absolute after:inset-0 after:origin-left after:bg-[#D5AD57] after:content-[''] after:animate-[heroProgress_6.5s_linear]" : ""}`} />
              </button>
            ))}
          </div>

          <button type="button" onClick={() => go(slide + 1)} aria-label="Next slide" className="h-[42px] w-[42px] cursor-pointer border border-white/35 bg-black/10 text-white transition duration-200 hover:bg-white hover:text-[#071A2F]">
            →
          </button>

          <span className="ml-4 flex items-center gap-2 text-[9px] tracking-[0.12em] text-white/65 max-[900px]:hidden">
            0{slide + 1}
            <i className="h-px w-[25px] bg-white/35" />
            0{slides.length}
          </span>
        </div>

        {/* Scroll cue */}
        <a className="absolute bottom-12 left-1/2 z-[5] flex items-center gap-[15px] text-[9px] uppercase tracking-[0.18em] text-white/65 max-[900px]:hidden" href="#explore">
          <span>Scroll to explore</span>

          <i className="grid h-[34px] w-[34px] place-items-center rounded-full border border-white/40 not-italic">
            ↓
          </i>
        </a>

        {/* Campus note */}
        <aside
          className="
      absolute bottom-0 right-0 z-[5]
      flex h-[108px] w-[310px]
      flex-col
      border-l-[3px] border-[#D5AD57]
      bg-[rgba(7,26,47,0.92)]
      py-5 pl-[26px] pr-[70px]

      max-[900px]:hidden
    "
        >
          <small
            className="
        text-[9px] uppercase
        tracking-[0.15em]
        text-[#D5AD57]
      "
          >
            Explore our campus
          </small>

          <strong
            className="
        mt-1.5
        font-['Libre_Caslon_Display']
        text-xl font-normal
      "
          >
            Book a guided visit
          </strong>

          <a
            href="#"
            aria-label="Book a guided campus visit"
            className="
        absolute right-[22px] top-[33px]
        grid h-[38px] w-[38px]
        place-items-center
        rounded-full
        border border-white/30
        text-white
      "
          >
            ↗
          </a>
        </aside>
      </section>

      <section
        id="explore"
        aria-labelledby="about-heading"
        className="
    relative overflow-hidden py-[100px]
    bg-[radial-gradient(circle_at_12%_23%,rgba(213,173,87,0.1),transparent_24%),linear-gradient(180deg,#fff_0%,#fbfaf7_64%,#F7F2E8_100%)]
    before:pointer-events-none
    before:absolute
    before:right-[-250px]
    before:top-[320px]
    before:h-[460px]
    before:w-[460px]
    before:rounded-full
    before:border
    before:border-gold/25
    before:shadow-[0_0_0_70px_rgba(213,173,87,0.035),0_0_0_140px_rgba(213,173,87,0.025)]
    before:content-['']
  "
      >
        <div className="container mx-auto">

          {/* Recognition Strip */}
          <div
            className="
    relative z-[3]
    mx-auto
    grid grid-cols-3
    overflow-hidden
    border border-gold/30
    bg-navy
    px-[18px] py-[25px]
    text-white
    shadow-[0_22px_55px_rgba(7,26,47,0.2)]

    before:pointer-events-none
    before:absolute
    before:inset-0
    before:bg-[linear-gradient(120deg,rgba(255,255,255,0.045),transparent_34%)]
    before:content-['']

    max-[900px]:max-w-[680px]
    max-[900px]:grid-cols-1
    max-[900px]:px-[22px]
    max-[900px]:py-3

    max-[560px]:-translate-y-7
    max-[560px]:px-[15px]
    max-[560px]:py-2
  "
            aria-label="Accreditations and memberships"
          >
            {recognitions.map((item, index) => (
              <article
                key={item.mark}
                className={`
            grid min-w-0
            grid-cols-[84px_1fr]
            items-center
            gap-[19px]
            px-[26px] py-1

            max-[900px]:grid-cols-[74px_1fr]
            max-[900px]:px-[5px]
            max-[900px]:py-4

            max-[560px]:grid-cols-[65px_1fr]
            max-[560px]:gap-[13px]

            ${index !== 0
                    ? `
                  border-l border-white/[0.18]
                  max-[900px]:border-l-0
                  max-[900px]:border-t
                  max-[900px]:border-t-white/[0.15]
                `
                    : ""
                  }
          `}
              >
                <div
                  aria-hidden="true"
                  className="
              grid h-[68px]
              place-content-center
              border border-gold/55
              bg-white
              text-center
              text-navy
              shadow-[inset_0_0_0_4px_#f8f4e9]

              max-[900px]:h-[58px]
              max-[560px]:h-[52px]
            "
                >
                  <span
                    className="
                font-sans
                text-[17px]
                font-bold
                leading-none
                tracking-[0.035em]
                text-gold-dark

                max-[560px]:text-sm
              "
                  >
                    {item.mark}
                  </span>

                  <small
                    className="
                mt-[7px]
                text-[7px]
                uppercase
                tracking-[0.16em]
              "
                  >
                    {index === 0 ? "Accredited" : "Member"}
                  </small>
                </div>

                <div>
                  <h3
                    className="
                mb-1.5
                mt-0
                text-base
                leading-[1.35]
                text-[#F2CE7D]

                max-[560px]:text-[13px]
              "
                  >
                    {item.title}
                  </h3>

                  <p
                    className="
                m-0
                text-xs
                leading-[1.55]
                text-white/[0.69]

                max-[560px]:text-[10px]
              "
                  >
                    {item.description}
                  </p>
                </div>
              </article>
            ))}
          </div>

          {/* Main About Content */}
          <div
            className="
        relative z-[2]
        my-[70px]
        grid
        grid-cols-[minmax(400px,0.88fr)_minmax(520px,1.12fr)]
        items-center
        gap-[clamp(54px,7vw,104px)]

        max-[900px]:mx-auto
        max-[900px]:mb-[70px]
        max-[900px]:mt-[10px]
        max-[900px]:max-w-[680px]
        max-[900px]:grid-cols-1
        max-[900px]:gap-[46px]

        max-[560px]:gap-10
      "
          >

            {/* Images */}
            <div
              className="
          relative
          h-[580px]

          before:absolute
          before:left-[-28px]
          before:top-[52px]
          before:h-[72%]
          before:w-[76%]
          before:border
          before:border-gold/55
          before:content-['']

          after:absolute
          after:bottom-[74px]
          after:left-[-55px]
          after:-z-[1]
          after:h-[118px]
          after:w-[118px]
          after:bg-[radial-gradient(rgba(12,39,68,0.34)_1.15px,transparent_1.15px)]
          after:bg-[length:10px_10px]
          after:content-['']

          max-[900px]:mx-auto
          max-[900px]:h-[520px]
          max-[900px]:w-full
          max-[900px]:max-w-[560px]

          max-[560px]:h-[410px]
          max-[560px]:before:left-[-8px]
          max-[560px]:before:top-[35px]
          max-[560px]:after:hidden
        "
              aria-label="Students learning at ISBM University"
            >
              <figure
                className="
            group
            absolute
            left-0
            top-20
            m-0
            h-[430px]
            w-[57%]
            overflow-hidden
            rounded-[2px_2px_2px_72px]
            bg-[#E8E0D1]
            shadow-[0_24px_55px_rgba(7,26,47,0.16)]

            max-[560px]:top-[65px]
            max-[560px]:h-[300px]
            max-[560px]:w-[60%]
            max-[560px]:rounded-[2px_2px_2px_40px]
          "
              >
                <img
                  src={about1}
                  alt="ISBM University students walking together on campus"
                  className="
              block
              h-full
              w-full
              object-cover
              object-[35%_center]
              transition-transform
              duration-[800ms]
              ease-in-out
              group-hover:scale-[1.04]
            "
                />
              </figure>

              <figure
                className="
            group
            absolute
            right-0
            top-3
            m-0
            h-[492px]
            w-[52%]
            overflow-hidden
            rounded-[2px_70px_2px_2px]
            border-[8px]
            border-white
            bg-[#E8E0D1]
            shadow-[0_24px_55px_rgba(7,26,47,0.16)]

            max-[560px]:h-[340px]
            max-[560px]:w-[55%]
            max-[560px]:rounded-[2px_42px_2px_2px]
            max-[560px]:border-[5px]
          "
              >
                <img
                  src={about2}
                  alt="Students collaborating during an academic activity"
                  className="
              block
              h-full
              w-full
              object-cover
              object-[65%_center]
              transition-transform
              duration-[800ms]
              ease-in-out
              group-hover:scale-[1.04]
            "
                />
              </figure>

              {/* NAAC Seal */}
              <div
                aria-hidden="true"
                className="
            absolute
            bottom-[22px]
            right-[-24px]
            z-[3]
            grid
            h-[148px]
            w-[148px]
            place-content-center
            rounded-full
            border-[6px]
            border-white
            bg-gold
            text-center
            text-navy
            shadow-[0_16px_35px_rgba(7,26,47,0.19)]

            after:absolute
            after:inset-[7px]
            after:rounded-full
            after:border
            after:border-navy/30
            after:content-['']

            max-[560px]:bottom-0
            max-[560px]:right-[-3px]
            max-[560px]:h-[112px]
            max-[560px]:w-[112px]
            max-[560px]:border-4
          "
              >
                <strong
                  className="
              relative z-[1]
              font-serif
              text-[34px]
              font-bold
              leading-none

              max-[560px]:text-[27px]
            "
                >
                  NAAC
                </strong>

                <span
                  className="
              relative z-[1]
              mt-[7px]
              text-[8px]
              uppercase
              leading-[1.4]
              tracking-[0.12em]

              max-[560px]:text-[6px]
            "
                >
                  Accredited
                </span>
              </div>
            </div>

            {/* Text Content */}
            <div
              className="
          pt-1.5
          max-[900px]:p-0
        "
            >
              <div
                className="
            mb-[18px]
            flex
            items-center
            gap-[13px]
            text-[10px]
            font-bold
            uppercase
            tracking-[0.2em]
            text-[#9A762F]

            max-[560px]:tracking-[0.14em]
          "
              >
                <span className="h-px w-[34px] bg-gold" />

                Explore what makes us exceptional
              </div>

              <h2
                id="about-heading"
                className="
            mb-5
            mt-0
            max-w-[630px]
            font-serif
            text-[clamp(40px,4vw,61px)]
            font-normal
            leading-[1.06]
            tracking-[-0.025em]
            text-navy

            [&_em]:font-normal
            [&_em]:italic
            [&_em]:text-gold-dark

            max-[560px]:text-[40px]
          "
              >
                <em>ISBM University</em> - A Legacy of <em>Excellence</em> &amp;
                Growth
              </h2>

              <p
                className="
            mb-[15px]
            mt-0
            max-w-[680px]
            text-lg
            leading-[1.72]
            text-ink
          "
              >
                From training to offer letters, ISBM University’s campus
                recruitment process is designed to open the right doors for your
                career.
              </p>

              <p
                className="
            mb-[15px]
            mt-0
            max-w-[680px]
            text-base
            leading-[1.75]
            text-[#596778]
          "
              >
                Established and approved by the Government of Chhattisgarh under
                the Chhattisgarh Private Universities (Establishment and
                Operation) Act, 2005 (Amendment Act 2016), this private
                University of Chhattisgarh is dedicated to supporting the needs
                of a superior level of higher education in India by conferring
                career-essential degrees, diplomas and certificates.
              </p>

              <p
                className="
            mb-[15px]
            mt-0
            max-w-[680px]
            text-base
            leading-[1.75]
            text-[#596778]
          "
              >
                As a NAAC accredited and UGC approved{" "}
                <strong>private university in India,</strong> ISBM University is
                recognised as the{" "}
                <strong>best private university in Chhattisgarh</strong> for
                students seeking industry-relevant, future-ready education —
                backed by outcome-focused pre-placement and placement support
                from day one.
              </p>

              {/* Feature Cards */}
              <div
                className="
            mt-7
            grid
            grid-cols-2
            gap-3.5

            max-[560px]:grid-cols-1
          "
              >
                {differentiators.map((item) => (
                  <a
                    href="#"
                    key={item.title}
                    className="
                group
                relative
                grid
                min-h-[160px]
                grid-cols-[44px_1fr]
                gap-3.5
                overflow-hidden
                border
                border-[#E7DFD0]
                bg-white/[0.82]
                px-[19px]
                py-[22px]
                shadow-[0_12px_30px_rgba(7,26,47,0.065)]
                transition-all
                duration-300
                ease-in-out

                after:absolute
                after:bottom-0
                after:left-0
                after:h-[3px]
                after:w-0
                after:bg-gold
                after:transition-[width]
                after:duration-300
                after:ease-in-out
                after:content-['']

                hover:-translate-y-[5px]
                hover:border-gold/75
                hover:shadow-[0_20px_38px_rgba(7,26,47,0.11)]
                hover:after:w-full

                max-[560px]:min-h-[145px]
              "
                  >
                    <span
                      className="
                  grid
                  h-[42px]
                  w-[42px]
                  place-items-center
                  rounded-full
                  bg-ivory
                  text-[#9A762F]

                  [&_svg]:w-[23px]
                  [&_svg]:fill-none
                  [&_svg]:stroke-current
                  [&_svg]:[stroke-width:1.55]
                  [&_svg]:[stroke-linecap:round]
                  [&_svg]:[stroke-linejoin:round]
                "
                    >
                      <FeatureIcon type={item.icon} />
                    </span>

                    <span className="flex min-w-0 flex-col">
                      <strong
                        className="
                    min-h-[39px]
                    text-[15px]
                    leading-[1.45]
                    text-navy
                  "
                      >
                        {item.title}
                      </strong>

                      <small
                        className="
                    mt-2
                    text-xs
                    leading-[1.5]
                    text-[#718090]
                  "
                      >
                        {item.description}
                      </small>

                      <b
                        className="
                    mt-auto
                    text-[10px]
                    uppercase
                    tracking-[0.11em]
                    text-[#8E6B2D]
                  "
                      >
                        Discover more

                        <i className="ml-[10px] not-italic">
                          ↗
                        </i>
                      </b>
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* University Statistics */}
          <div
            className="
    relative
    z-[2]
    overflow-hidden
    bg-navy
    px-[62px]
    pb-12
    pt-[58px]
    text-white
    shadow-[0_25px_55px_rgba(7,26,47,0.16)]

    before:pointer-events-none
    before:absolute
    before:inset-0
    before:z-0
    before:bg-[linear-gradient(110deg,rgba(255,255,255,0.035),transparent_42%)]
    before:content-['']

    after:absolute
    after:left-0
    after:top-0
    after:z-[2]
    after:h-[3px]
    after:w-[150px]
    after:bg-gold
    after:content-['']

    max-[900px]:mx-auto
    max-[900px]:mt-[75px]
    max-[900px]:max-w-[680px]
    max-[900px]:px-9
    max-[900px]:pb-[38px]
    max-[900px]:pt-[46px]

    max-[560px]:mt-[60px]
    max-[560px]:px-6
    max-[560px]:pb-8
    max-[560px]:pt-10
  "
          >
            <div
              className="
          grid
          grid-cols-[210px_1fr]
          items-center
          gap-[38px]
          border-b
          border-white/[0.13]
          pb-[35px]

          max-[900px]:grid-cols-1
          max-[900px]:gap-3.5
        "
            >
              <span
                className="
            text-[10px]
            font-bold
            uppercase
            tracking-[0.19em]
            text-gold
          "
              >
                ISBM University at a glance
              </span>

              <h2
                className="
            m-0
            font-serif
            text-[clamp(30px,3vw,44px)]
            font-normal
            leading-[1.16]

            [&_em]:font-normal
            [&_em]:italic
            [&_em]:text-gold-dark
          "
              >
                <em>The Best University</em> in Chhattisgarh For Higher
                Education
              </h2>
            </div>

            <div
              className="
          grid
          grid-cols-4
          pt-[38px]

          max-[900px]:grid-cols-2
          max-[900px]:gap-y-[30px]

          max-[560px]:gap-0
        "
            >
              {universityStats.map((item, index) => (
                <article
                  key={item.value}
                  className={`
              px-[29px]

              ${index !== 0 ? "border-l border-gold/40" : "pl-0"}

              ${index === 2
                      ? `
                    max-[900px]:border-l-0
                    max-[900px]:pl-0

                    max-[560px]:border-t
                    max-[560px]:border-t-white/[0.12]
                  `
                      : ""
                    }

              ${index === 3
                      ? `
                    max-[560px]:border-t
                    max-[560px]:border-t-white/[0.12]
                  `
                      : ""
                    }

              max-[560px]:px-[15px]
              max-[560px]:py-6

              ${index === 0
                      ? "max-[560px]:pb-6 max-[560px]:pl-0 max-[560px]:pr-[15px] max-[560px]:pt-6"
                      : ""
                    }
            `}
                >
                  <strong
                    className="
                block
                font-serif
                text-[43px]
                font-medium
                leading-none
                text-gold

                max-[560px]:text-[34px]
              "
                  >
                    {item.value}
                  </strong>

                  <p
                    className="
                mb-0
                mt-3
                max-w-[190px]
                text-xs
                leading-[1.55]
                text-white/[0.66]

                max-[560px]:text-[9px]
              "
                  >
                    {item.label}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="programmes" className="relative overflow-hidden bg-[#f8f9fa] py-[100px] [background-image:linear-gradient(90deg,rgba(213,173,87,0.055)_1px,transparent_1px),linear-gradient(rgba(213,173,87,0.055)_1px,transparent_1px)] [background-size:48px_48px] before:absolute before:bottom-[-240px] before:left-[-210px] before:h-[520px] before:w-[520px] before:rounded-full before:border before:border-[rgba(213,173,87,0.28)] before:content-[''] before:[box-shadow:0_0_0_70px_rgba(213,173,87,0.035),0_0_0_140px_rgba(213,173,87,0.02)] max-[900px]:py-20 max-[560px]:py-[60px]">
        <div className="container mx-auto">
          <div className="relative z-[1] mx-auto grid grid-cols-[minmax(400px,0.92fr)_minmax(570px,1.08fr)] items-center gap-[clamp(64px,8vw,118px)] max-[900px]:max-w-[680px] max-[900px]:grid-cols-1 max-[900px]:gap-[45px]">
            <div className="max-w-[560px] max-[900px]:max-w-none">

              <Eyebrow dark>Find your academic pathway</Eyebrow>
              <Title before="The Right Education" after="Your Global Ambitions" highlight="Can Realize" position="middle" theme="gold" />

              <p className="my-4 text-base leading-[1.78] text-[#617081]">
                ISBM University offers a wide range of academic programmes that
                combine theoretical foundations with real-world applications. As
                one of the <strong>best colleges in Raipur -</strong> the
                capital city of Chhattisgarh- our curriculum spans undergraduate
                to doctoral levels, equipping students with the skills required
                to thrive in a competitive global environment.
              </p>
              <p className="mb-4 text-base leading-[1.78] text-[#617081]">
                Every programme emphasizes research, innovation and holistic
                development. Students gain mentorship, industry exposure and
                opportunities for practical learning and entrepreneurship — the
                hallmark of a genuine institution of higher education, and one
                of the reasons ISBM is regarded among the{" "}
                <strong>top colleges in Chhattisgarh</strong> state.
              </p>
              <div className="relative mt-[50px] h-[180px] max-[900px]:h-auto">
                <img alt="Arrow" src={arrow} className="absolute bottom-[50px] left-[300px] h-auto w-[120px] max-w-full object-contain max-[900px]:hidden" />
                <a href="#" className="absolute -right-[15%] bottom-[-35px] mt-7 flex h-[58px] w-[206px] origin-left -rotate-[50deg] items-center justify-between bg-[#071a2f] py-0 pl-[22px] pr-[17px] text-[10px] font-bold uppercase tracking-[0.1em] text-white no-underline shadow-[0_14px_28px_rgba(7,26,47,0.18)] transition-all duration-300 before:absolute before:left-0 before:top-0 before:h-full before:w-1 before:bg-[#d5ad57] before:content-[''] hover:rotate-0 hover:-translate-y-1 hover:bg-[#0c2744] max-[900px]:static max-[900px]:right-auto max-[900px]:bottom-auto max-[900px]:rotate-0 max-[900px]:translate-y-0">
                  <span>View all programmes</span>
                  <i className="grid h-[31px] w-[31px] place-items-center rounded-full bg-[#d5ad57] not-italic text-[#071a2f]">↗</i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-[17px] max-[560px]:grid-cols-1">
              <div className="grid gap-[17px] pt-[60px] max-[560px]:pt-0">
                <a href="#" className="group relative isolate block min-h-[260px] overflow-hidden rounded-[28px] bg-[#071a2f] text-white shadow-[0_15px_32px_rgba(7,26,47,0.14)] max-[560px]:min-h-[230px]">
                  <img src={p1} alt="Research and development" className="absolute inset-0 -z-[2] h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]" />
                  <span className="absolute inset-0 -z-[1] bg-[linear-gradient(180deg,rgba(7,26,47,0.12),rgba(7,26,47,0.9)),linear-gradient(90deg,rgba(7,26,47,0.55),transparent_70%)]"></span>
                  <span className="absolute inset-0 flex flex-col items-start px-[22px] pb-[19px] pt-[23px]">
                    <small className="text-[8px] font-bold uppercase tracking-[0.15em] text-[#d5ad57]">Create new knowledge</small>
                    <strong className="mt-[7px] max-w-[240px] [font-family:'Libre_Caslon_Display',Georgia,serif] text-[25px] font-normal leading-[1.14]">Research and Development</strong>
                    <b className="mt-auto flex min-h-[35px] w-full items-center justify-between border-y border-[rgba(255,255,255,0.44)] px-3 text-[8px] font-bold uppercase tracking-[0.1em] text-[rgba(255,255,255,0.88)] transition-all duration-300 group-hover:border-[#d5ad57] group-hover:bg-[#d5ad57] group-hover:text-[#071a2f]">View programme <i className="not-italic text-[#d5ad57] group-hover:text-[#071a2f]">↗</i></b>
                  </span>
                </a>

                <a href="#" className="group relative isolate block min-h-[260px] overflow-hidden rounded-[28px] bg-[#071a2f] text-white shadow-[0_15px_32px_rgba(7,26,47,0.14)] max-[560px]:min-h-[230px]">
                  <img src={p2} alt="Post graduation" className="absolute inset-0 -z-[2] h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]" />
                  <span className="absolute inset-0 -z-[1] bg-[linear-gradient(180deg,rgba(7,26,47,0.12),rgba(7,26,47,0.9)),linear-gradient(90deg,rgba(7,26,47,0.55),transparent_70%)]"></span>
                  <span className="absolute inset-0 flex flex-col items-start px-[22px] pb-[19px] pt-[23px]">
                    <small className="text-[8px] font-bold uppercase tracking-[0.15em] text-[#d5ad57]">Advance your expertise</small>
                    <strong className="mt-[7px] max-w-[240px] [font-family:'Libre_Caslon_Display',Georgia,serif] text-[25px] font-normal leading-[1.14]">Post Graduation</strong>
                    <b className="mt-auto flex min-h-[35px] w-full items-center justify-between border-y border-[rgba(255,255,255,0.44)] px-3 text-[8px] font-bold uppercase tracking-[0.1em] text-[rgba(255,255,255,0.88)] transition-all duration-300 group-hover:border-[#d5ad57] group-hover:bg-[#d5ad57] group-hover:text-[#071a2f]">View programme <i className="not-italic text-[#d5ad57] group-hover:text-[#071a2f]">↗</i></b>
                  </span>
                </a>
              </div>

              <div className="grid gap-[17px]">
                <a href="#" className="group relative isolate block min-h-[190px] overflow-hidden rounded-[28px] bg-[#071a2f] text-white shadow-[0_15px_32px_rgba(7,26,47,0.14)] max-[560px]:min-h-[230px]">
                  <img src={p3} alt="Graduation" className="absolute inset-0 -z-[2] h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]" />
                  <span className="absolute inset-0 -z-[1] bg-[linear-gradient(180deg,rgba(7,26,47,0.12),rgba(7,26,47,0.9)),linear-gradient(90deg,rgba(7,26,47,0.55),transparent_70%)]"></span>
                  <span className="absolute inset-0 flex flex-col items-start px-[22px] pb-[19px] pt-[23px]">
                    <small className="text-[8px] font-bold uppercase tracking-[0.15em] text-[#d5ad57]">Build your foundation</small>
                    <strong className="mt-[7px] max-w-[240px] [font-family:'Libre_Caslon_Display',Georgia,serif] text-[25px] font-normal leading-[1.14]">Graduation</strong>
                    <b className="mt-auto flex min-h-[35px] w-full items-center justify-between border-y border-[rgba(255,255,255,0.44)] px-3 text-[8px] font-bold uppercase tracking-[0.1em] text-[rgba(255,255,255,0.88)] transition-all duration-300 group-hover:border-[#d5ad57] group-hover:bg-[#d5ad57] group-hover:text-[#071a2f]">View programme <i className="not-italic text-[#d5ad57] group-hover:text-[#071a2f]">↗</i></b>
                  </span>
                </a>

                <a href="#" className="group relative isolate block min-h-[190px] overflow-hidden rounded-[28px] bg-[#071a2f] text-white shadow-[0_15px_32px_rgba(7,26,47,0.14)] max-[560px]:min-h-[230px]">
                  <img src={p4} alt="Diploma" className="absolute inset-0 -z-[2] h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]" />
                  <span className="absolute inset-0 -z-[1] bg-[linear-gradient(180deg,rgba(7,26,47,0.12),rgba(7,26,47,0.9)),linear-gradient(90deg,rgba(7,26,47,0.55),transparent_70%)]"></span>
                  <span className="absolute inset-0 flex flex-col items-start px-[22px] pb-[19px] pt-[23px]">
                    <small className="text-[8px] font-bold uppercase tracking-[0.15em] text-[#d5ad57]">Develop practical skills</small>
                    <strong className="mt-[7px] max-w-[240px] [font-family:'Libre_Caslon_Display',Georgia,serif] text-[25px] font-normal leading-[1.14]">Diploma</strong>
                    <b className="mt-auto flex min-h-[35px] w-full items-center justify-between border-y border-[rgba(255,255,255,0.44)] px-3 text-[8px] font-bold uppercase tracking-[0.1em] text-[rgba(255,255,255,0.88)] transition-all duration-300 group-hover:border-[#d5ad57] group-hover:bg-[#d5ad57] group-hover:text-[#071a2f]">View programme <i className="not-italic text-[#d5ad57] group-hover:text-[#071a2f]">↗</i></b>
                  </span>
                </a>

                <a href="#" className="group relative isolate block min-h-[190px] overflow-hidden rounded-[28px] bg-[#071a2f] text-white shadow-[0_15px_32px_rgba(7,26,47,0.14)] max-[560px]:min-h-[230px]">
                  <img src={p5} alt="Certificate" className="absolute inset-0 -z-[2] h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]" />
                  <span className="absolute inset-0 -z-[1] bg-[linear-gradient(180deg,rgba(7,26,47,0.12),rgba(7,26,47,0.9)),linear-gradient(90deg,rgba(7,26,47,0.55),transparent_70%)]"></span>
                  <span className="absolute inset-0 flex flex-col items-start px-[22px] pb-[19px] pt-[23px]">
                    <small className="text-[8px] font-bold uppercase tracking-[0.15em] text-[#d5ad57]">Learn with flexibility</small>
                    <strong className="mt-[7px] max-w-[240px] [font-family:'Libre_Caslon_Display',Georgia,serif] text-[25px] font-normal leading-[1.14]">Certificate</strong>
                    <b className="mt-auto flex min-h-[35px] w-full items-center justify-between border-y border-[rgba(255,255,255,0.44)] px-3 text-[8px] font-bold uppercase tracking-[0.1em] text-[rgba(255,255,255,0.88)] transition-all duration-300 group-hover:border-[#d5ad57] group-hover:bg-[#d5ad57] group-hover:text-[#071a2f]">View programme <i className="not-italic text-[#d5ad57] group-hover:text-[#071a2f]">↗</i></b>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Accreditations />

      <Programmes />

      <section className="relative mx-[70px] my-[100px] overflow-hidden rounded-[32px] bg-[linear-gradient(135deg,#8b1e3f_0%,#551126_100%)] p-[110px] before:absolute before:right-[-120px] before:top-[-180px] before:h-[420px] before:w-[420px] before:rounded-full before:bg-[rgba(255,255,255,0.08)] before:content-[''] after:absolute after:bottom-[-120px] after:left-[-80px] after:h-[300px] after:w-[300px] after:rounded-full after:bg-[rgba(255,255,255,0.06)] after:content-[''] max-[768px]:mx-[15px] max-[768px]:my-[60px] max-[768px]:px-[25px] max-[768px]:py-[70px]">
        <div className="container mx-auto">
          <div className="relative z-[2] m-auto text-center">
            <span className="mb-[25px] inline-block rounded-[30px] bg-[rgba(255,255,255,0.12)] px-[18px] py-2 text-[13px] tracking-[2px] text-white">ADMISSIONS • 2026</span>
            <h2 className="mb-[25px] text-white [font-family:'Libre_Caslon_Display',Georgia,serif] text-[64px] font-normal leading-[1.15] max-[768px]:text-[42px]">
              Right Place.
              <em className="italic text-[#ffd36d]"> Right Time.</em>
            </h2>
            <p className="mb-10 text-[17px] leading-[1.9] text-[rgba(255,255,255,0.9)] max-[768px]:text-[15px]">
              Join one of the best higher education universities in India - ISBM
              University and become part of an academic community committed to
              innovation, research and employability. Applications are now open
              for Undergraduate, Postgraduate, Diploma and Doctoral programmes.
            </p>
            <div className="flex flex-wrap justify-center gap-[18px] max-[768px]:flex-col">
              <a href="/apply-now" className="rounded-[50px] bg-white px-[38px] py-4 font-bold text-[#8b1e3f] no-underline transition-all duration-[350ms] hover:-translate-y-[3px] hover:shadow-[0_18px_35px_rgba(0,0,0,0.2)] max-[768px]:w-full max-[768px]:text-center">Apply Now</a>
              <a href="/admissions" className="rounded-[50px] border-2 border-[rgba(255,255,255,0.35)] px-[38px] py-4 font-semibold text-white no-underline transition-all duration-[350ms] hover:bg-white hover:text-[#8b1e3f] max-[768px]:w-full max-[768px]:text-center">Download Prospectus</a>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white py-[110px]">
        <div className="container mx-auto">
          <div className="grid grid-cols-[42%_55%] items-center gap-[50px] max-[900px]:grid-cols-1">
            <div>
              <div className="mb-[18px] flex items-center gap-[13px] text-[10px] font-bold uppercase tracking-[0.2em] text-[#9a762f]">
                <span className="h-px w-[34px] bg-[#d5ad57]"></span>
                GLOBAL COLLABORATIONS
              </div>
              <h2 className="my-[25px] text-[#0f2343] [font-family:'Libre_Caslon_Display',Georgia,serif] text-[58px] font-normal leading-[1.1]">
                International Partnerships –<em className="italic text-[#8b1e3f]"> For a Universal Career</em>
              </h2>
              <p className="mb-[18px] leading-[1.9] text-[#6b7280]">
                The primary objective of the International Partnerships is to
                promote a means for <strong>global education</strong> through
                academic credibility and cross-cultural exchange within the
                academic realm. These partnerships foster global learning
                opportunities for students, faculty and staff members of ISBM
                University.
              </p>
              <p className="mb-[18px] leading-[1.9] text-[#6b7280]">
                Through these collaborations, ISBM University provides students
                with exposure to international educational practices, diverse
                perspectives and multicultural learning environments. The
                partnerships also encourage joint-research, faculty exchange
                programmes and academic collaborations with renowned
                universities across the world, reinforcing ISBM's position as
                one of the <strong>top colleges in Chhattisgarh</strong> state.
              </p>
            </div>

            <div className="flex flex-wrap">
              {[{ logo: abertayLogo, alt: "Abertay University" }, { logo: diuLogo, alt: "Dresden International University" }, { logo: henryLogo, alt: "Henry Harvin" }, { logo: indianaLogo, alt: "Indiana Tech" }, { logo: rushfordLogo, alt: "Rushford Business School" }].map((partner) => (
                <div className="w-1/2 p-3" key={partner.alt}>
                  <div className="group flex h-full min-h-[170px] items-center justify-center rounded-[20px] border border-[#eee] bg-white p-[25px] transition-all duration-[350ms] [box-shadow:0_0_0_70px_rgba(213,173,87,0.035),0_0_0_140px_rgba(213,173,87,0.025)] hover:-translate-y-2 hover:shadow-[0_18px_40px_rgba(0,0,0,0.08)]">
                    <img src={partner.logo} alt={partner.alt} className="max-w-full object-contain transition-transform duration-[350ms] group-hover:scale-105" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-[#fdf7fc] py-[120px] [background-image:radial-gradient(circle_at_100%_0,rgba(168,38,130,0.09),transparent_30%)] max-[700px]:py-[78px]">
        <div className="container mx-auto">
          <div className="flex items-center gap-[clamp(55px,6vw,90px)] max-[1050px]:flex-col max-[1050px]:items-stretch max-[700px]:gap-[55px]">
            <div className="min-w-0 flex-[0_1_44%] max-[1050px]:basis-auto">
              <div className="mb-[18px] flex items-center gap-[13px] text-[10px] font-bold uppercase tracking-[0.2em] text-[#9a762f]">
                <span className="h-px w-[34px] bg-[#d5ad57]"></span>
                PLACEMENTS
              </div>

              <h2 className="my-[25px] max-w-[630px] text-[#0f2343] [font-family:'Libre_Caslon_Display',Georgia,serif] text-[clamp(48px,5vw,68px)] font-normal leading-[1.07] tracking-[-0.035em] max-[1050px]:max-w-[760px] max-[700px]:text-[44px]">
                Launch Your Career
                <em className="block font-normal text-[#8b1e3f]"> with Confidence</em>
              </h2>

              <p className="mb-[42px] max-w-[650px] text-[14px] leading-[1.85] text-[#667080] max-[1050px]:max-w-[850px] max-[700px]:mb-8 max-[700px]:text-[13px]">
                ISBM University - being one of the <strong>best colleges in Raipur</strong>
                ensures academic excellence is at par with industry
                expectations. We provide dedicated placement assistance,
                corporate partnerships, internships, career counselling, skill
                development and campus recruitment drives, helping students
                transition confidently from classroom to career.
              </p>

              <div className="mb-[42px] flex flex-wrap gap-[10px] max-[700px]:gap-2 [&_.placement-stat]:relative [&_.placement-stat]:flex [&_.placement-stat]:min-h-[135px] [&_.placement-stat]:min-w-[145px] [&_.placement-stat]:flex-[1_1_calc(33.333%_-_10px)] [&_.placement-stat]:flex-col [&_.placement-stat]:justify-end [&_.placement-stat]:overflow-hidden [&_.placement-stat]:rounded-[17px] [&_.placement-stat]:border [&_.placement-stat]:border-[rgba(15,35,67,0.09)] [&_.placement-stat]:bg-[rgba(255,255,255,0.86)] [&_.placement-stat]:px-5 [&_.placement-stat]:py-[23px] [&_.placement-stat]:shadow-[0_12px_32px_rgba(15,35,67,0.07)] [&_.placement-stat]:transition-all [&_.placement-stat]:duration-[350ms] [&_.placement-stat]:animate-[placementStatReveal_0.6s_ease_var(--stat-delay,0ms)_both] [&_.placement-stat::before]:absolute [&_.placement-stat::before]:right-[-35px] [&_.placement-stat::before]:top-[-35px] [&_.placement-stat::before]:h-[70px] [&_.placement-stat::before]:w-[70px] [&_.placement-stat::before]:rounded-full [&_.placement-stat::before]:bg-[rgba(168,38,130,0.08)] [&_.placement-stat::before]:content-[''] [&_.placement-stat::before]:transition-transform [&_.placement-stat::before]:duration-[350ms] [&_.placement-stat:hover]:-translate-y-[6px] [&_.placement-stat:hover]:border-[rgba(168,38,130,0.35)] [&_.placement-stat:hover]:shadow-[0_20px_45px_rgba(15,35,67,0.12)] [&_.placement-stat:hover::before]:scale-150 [&_.placement-stat__number]:absolute [&_.placement-stat__number]:left-5 [&_.placement-stat__number]:top-[17px] [&_.placement-stat__number]:text-[8px] [&_.placement-stat__number]:font-bold [&_.placement-stat__number]:tracking-[0.1em] [&_.placement-stat__number]:text-[#b5bac2] [&_.placement-stat_h3]:relative [&_.placement-stat_h3]:z-[1] [&_.placement-stat_h3]:m-0 [&_.placement-stat_h3]:whitespace-nowrap [&_.placement-stat_h3]:text-[clamp(27px,2.6vw,37px)] [&_.placement-stat_h3]:font-bold [&_.placement-stat_h3]:leading-none [&_.placement-stat_h3]:text-[#8b1e3f] [&_.placement-stat_h3_small]:text-[0.52em] [&_.placement-stat_h3_small]:font-bold [&_.placement-stat__label]:relative [&_.placement-stat__label]:z-[1] [&_.placement-stat__label]:mt-[9px] [&_.placement-stat__label]:block [&_.placement-stat__label]:text-[10px] [&_.placement-stat__label]:font-semibold [&_.placement-stat__label]:tracking-[0.04em] [&_.placement-stat__label]:text-[#6d7683] max-[700px]:[&_.placement-stat]:min-h-[120px] max-[700px]:[&_.placement-stat]:min-w-[130px] max-[700px]:[&_.placement-stat]:flex-[1_1_calc(50%_-_8px)] max-[700px]:[&_.placement-stat]:px-4 max-[700px]:[&_.placement-stat]:py-5 max-[700px]:[&_.placement-stat_h3]:text-[28px] max-[700px]:[&_.placement-stat__number]:left-4 max-[390px]:[&_.placement-stat]:basis-full" aria-label="Placement statistics">
                {placementStats.map((stat, index) => (
                  <AnimatedStat key={stat.label} value={stat.value} suffix={stat.suffix} label={stat.label} index={index} />
                ))}
              </div>

              <a href="/placements" className="group inline-flex items-center gap-[25px] rounded-[50px] bg-[#8b1e3f] py-4 pl-7 pr-[22px] text-[11px] font-bold uppercase tracking-[0.05em] text-white no-underline transition-all duration-[350ms] hover:-translate-y-[3px] hover:bg-[#8f1f70] hover:text-white hover:shadow-[0_15px_35px_rgba(168,38,130,0.28)]">
                <span>Explore Placements</span>
                <i className="grid h-[30px] w-[30px] place-items-center rounded-full bg-[rgba(255,255,255,0.16)] not-italic transition-transform duration-300 group-hover:translate-x-[3px]">→</i>
              </a>
            </div>

            <div className="relative flex min-w-0 flex-[1_1_56%] flex-wrap gap-[15px] max-[1050px]:basis-auto max-[700px]:gap-2">
              {placementGallery.map((image, index) => (
                <figure className={`group relative m-0 min-w-0 overflow-hidden bg-[#e9e7e8] after:absolute after:inset-0 after:bg-[linear-gradient(180deg,transparent_55%,rgba(7,27,51,0.76))] after:content-[''] max-[700px]:flex-[1_1_calc(50%_-_4px)] max-[700px]:rounded-[15px] ${index === 0 ? "h-[410px] flex-[1_1_calc(50%_-_8px)] max-[700px]:h-[285px]" : index === 1 ? "mt-[55px] h-[310px] flex-[1_1_calc(50%_-_8px)] max-[700px]:mt-0 max-[700px]:h-[285px]" : index === 2 ? "h-[240px] flex-[1_1_calc(39%_-_8px)] max-[700px]:h-[210px]" : "h-[240px] flex-[1_1_calc(61%_-_8px)] max-[700px]:h-[210px]"} rounded-[22px]`} key={index}>
                  <img src={image} alt={`ISBM University placement activity ${index + 1}`} loading="lazy" className="block h-full w-full object-cover transition-transform duration-[650ms] [transition-timing-function:cubic-bezier(0.2,0.7,0.2,1)] group-hover:scale-[1.07]" />
                  <figcaption className="absolute bottom-[18px] left-5 right-5 z-[2] flex items-center justify-between text-white max-[700px]:bottom-[13px] max-[700px]:left-[13px] max-[700px]:right-[13px]">
                    <span className="text-[9px] font-bold uppercase tracking-[0.1em] max-[700px]:max-w-[90px] max-[700px]:text-[7px]">
                      {index === 0 && "Career Readiness"}
                      {index === 1 && "Industry Interaction"}
                      {index === 2 && "Placement Drives"}
                      {index === 3 && "Student Success"}
                    </span>
                    <small className="text-[8px] text-[rgba(255,255,255,0.58)]">{String(index + 1).padStart(2, "0")}</small>
                  </figcaption>
                </figure>
              ))}

              <div className="absolute left-1/2 top-[48%] z-[4] grid h-[125px] w-[125px] -translate-x-1/2 -translate-y-1/2 place-content-center rounded-full border-[6px] border-[#fdf7fc] bg-[#8b1e3f] text-center text-white shadow-[0_16px_35px_rgba(7,27,51,0.23)] max-[700px]:h-[92px] max-[700px]:w-[92px] max-[700px]:border-4">
                <span className="text-[7px] font-bold uppercase tracking-[0.1em]">Career-focused</span>
                <strong className="mt-[5px] [font-family:'Libre_Caslon_Display',Georgia,serif] text-[20px] font-normal max-[700px]:text-[16px]">Learning</strong>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Recruiters />
      <Alumni />
      <Awards />
      <Campuses />
      <Facilities />
      <Blogs />
      <FAQ />
      <NewslettersSection />
      <EventsSection />
      <CircularsNoticesSection />
      <Footer />
    </main >
  );
}

export default Home;
